import { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const languages = [
  { code: 'en', label: 'English' },
  { code: 'fr', label: 'Français' },
  { code: 'da', label: 'Dansk' },
  { code: 'de', label: 'Deutsch' },
];

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClick(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  const current = languages.find((l) => l.code === i18n.language) || languages[0];

  function changeLanguage(code: string) {
    i18n.changeLanguage(code);
    document.documentElement.lang = code;
    setOpen(false);
  }

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="flex items-center gap-2 rounded-full border border-background-200 bg-background-50 px-4 py-2 text-sm font-medium text-foreground-700 hover:border-primary-300 hover:text-foreground-900 transition-colors whitespace-nowrap cursor-pointer"
      >
        <i className="ri-global-line w-4 h-4 flex items-center justify-center" />
        <span>{current.label}</span>
        <i className={`ri-arrow-down-s-line w-4 h-4 flex items-center justify-center transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>

      {open && (
        <div className="absolute right-0 mt-2 w-40 overflow-hidden rounded-lg border border-background-200 bg-background-50 py-1 z-50">
          {languages.map((lang) => (
            <button
              key={lang.code}
              type="button"
              onClick={() => changeLanguage(lang.code)}
              className={`flex w-full items-center justify-between px-4 py-2 text-sm text-left whitespace-nowrap cursor-pointer transition-colors ${
                lang.code === current.code
                  ? 'bg-primary-100 text-primary-900 font-semibold'
                  : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              <span>{lang.label}</span>
              {lang.code === current.code && (
                <i className="ri-check-line w-4 h-4 flex items-center justify-center" />
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}